'use client';

import { Container } from '@mantine/core';
import styles from './OriginStoryPlayground.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';

export type OriginStoryPlaygroundSlice = {
    type: 'origin-story-playground';
    tone?: 'kids' | 'default';
    title: string;
    paragraphs: string[];
};

export default function OriginStoryPlayground({
    slice,
}: {
    slice: OriginStoryPlaygroundSlice;
}) {
    useAOS();

    const tone = slice.tone ?? 'kids';

    return (
        <section
            className={[
                styles.wrapper,
                tone === 'kids' ? styles.kids : styles.default,
            ].join(' ')}
            data-aos="fade-up"
        >
            <Container size="md" className={styles.container}>
                <div className={styles.panel}>
                    <h2 className={styles.title}>{slice.title}</h2>

                    <div className={styles.text}>
                        {slice.paragraphs.map((p, i) => (
                            <p key={i}>{p}</p>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
}
